import { Alert, Button, FloatingLabel, Form, Modal } from 'react-bootstrap'
import {
  forwardRef,
  useImperativeHandle,
  useState,
} from 'react'
import {
  Order_State_Enum_Enum,
  useInsertOrderStateMutation,
} from '../generated/urql.administrator'
import { OrderState2Label } from '../lib/order'

export type ChangeOrderStatusModalType = {
  show: (args: { orderId: number; currentState: Order_State_Enum_Enum }) => void
}

const ChangeOrderStatusModal = forwardRef<
  ChangeOrderStatusModalType,
  { onChange: () => void }
>(({ onChange }, ref) => {
  const [show, setShow] = useState(false)
  const [orderId, setOrderId] = useState<number>()
  const [selectedState, setSelectedState] = useState<Order_State_Enum_Enum>()
  const [generalError, setGeneralError] = useState<string>()
  const [{ fetching }, insertOrderState] = useInsertOrderStateMutation()

  useImperativeHandle(ref, () => ({
    show: ({ orderId, currentState }) => {
      setOrderId(orderId)
      setSelectedState(currentState)
      setGeneralError(undefined)
      setShow(true)
    },
  }))

  async function doChangeStatus() {
    if (!orderId || !selectedState) return
    setGeneralError(undefined)

    const { error } = await insertOrderState({ orderId, state: selectedState })
    if (error) {
      setGeneralError(error.message)
      return
    }

    setShow(false)
    onChange()
  }

  return (
    <Modal show={show} onHide={() => setShow(false)} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Zmień status zamówienia</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {generalError && <Alert variant="danger">{generalError}</Alert>}
        <Alert variant="warning">
          Zmiana statusu może wysłać powiadomienia do klienta. Ta operacja jest
          nieodwracalna — nowy status zostanie dodany do historii stanów
          zamówienia.
        </Alert>
        <FloatingLabel label="Nowy status" className="mb-3">
          <Form.Select
            value={selectedState ?? ''}
            onChange={(e) =>
              setSelectedState(e.target.value as Order_State_Enum_Enum)
            }
          >
            {Object.entries(OrderState2Label).map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </Form.Select>
        </FloatingLabel>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          Anuluj
        </Button>
        <Button
          variant="primary"
          onClick={doChangeStatus}
          disabled={fetching}
        >
          Zmień status
        </Button>
      </Modal.Footer>
    </Modal>
  )
})

export default ChangeOrderStatusModal
